import { get } from "./baseService";

export async function getFormations(page,limit) {
  const response = await get(`formations?page=${page}&limit=${limit}`, true);
  return response;
}

export async function getFormation(code) {
  const response = await get(`formations/${code}`, true);
  return response;
}
